import type Phaser from 'phaser';

type PhaserCanvasSizeOptions = {
	fallback: 'minimum' | 'viewport';
};

const MAX_DEVICE_PIXEL_RATIO = 2;

export function getDevicePixelRatio(): number {
	if (typeof window === 'undefined') {
		return 1;
	}

	return Math.min(window.devicePixelRatio || 1, MAX_DEVICE_PIXEL_RATIO);
}

export function syncPhaserCanvasSize(
	game: Phaser.Game,
	container: HTMLElement,
	{ fallback }: PhaserCanvasSizeOptions,
): void {
	const useViewport = fallback === 'viewport' && typeof window !== 'undefined';
	const fallbackWidth = useViewport ? window.innerWidth : 1;
	const fallbackHeight = useViewport ? window.innerHeight : 1;
	const width = Math.max(1, Math.round(container.clientWidth || fallbackWidth || 1));
	const height = Math.max(1, Math.round(container.clientHeight || fallbackHeight || 1));
	const pixelRatio = getDevicePixelRatio();

	game.canvas.style.width = `${width}px`;
	game.canvas.style.height = `${height}px`;
	game.scale.resize(Math.max(1, Math.round(width * pixelRatio)), Math.max(1, Math.round(height * pixelRatio)));
}
